import "./app/publicPath";
import Vue from "vue";
import Vuex from "vuex";
import NotificationService from "./app/services/NotificationService";
import TranslationService from "./app/services/TranslationService";

// import "bootstrap";
import Alert from "bootstrap/js/src/alert";
// import Button from "bootstrap/js/src/button";
import Carousel from "bootstrap/js/src/carousel";
import Collapse from "bootstrap/js/src/collapse";
import Dropdown from "bootstrap/js/src/dropdown";
import Modal from "bootstrap/js/src/modal";
import Popover from "bootstrap/js/src/popover";
// import Scrollspy from "bootstrap/js/src/scrollspy";
// import Tab from "bootstrap/js/src/tab";
// import Toast from "bootstrap/js/src/toast";
import Tooltip from "bootstrap/js/src/tooltip";
import Util from "bootstrap/js/src/util";
export {
    // Button,
    Util,
    Alert,
    Carousel,
    Collapse,
    Dropdown,
    Modal,
    Popover,
    // Scrollspy,
    // Tab,
    // Toast,
    Tooltip
};

import "owl.carousel";
import { createApp, beforeCreate } from "./app";
import "custom-event-polyfill";
import { initClientListeners, initClientStore, createStore } from "./app/store";
import { initListener } from "./app/services/ApiService";
import { mount } from "./mount";
import "./app/jQuery";

/* NK Additions for client only packages*/

// for vue-head usage visit https://bestofvue.com/repo/ktquez-vue-head-vuejs-meta-tags
// for vue-meta usage visit https://vue-meta.nuxtjs.org/
// We use it directly in Ceres\resources\js\src\app\extra\overrides\components\item\VariationSelect.vue
// import VueMeta from "vue-meta";
// Vue.use(VueMeta);

/* NK end of Additions */

Vue.prototype.$mount = mount;

// defines if the render location is the client
App.isSSR = false;
App.isSSREnabled = App.config.log.performanceSsr;

beforeCreate();

window.createApp = (selector) =>
{
    // client-specific bootstrapping logic...
    const app = createApp({
        template: "#ssr-script-container"
    }, store);

    app.$mount(selector, true);
    window.vueApp = app;

    initListener();

    initClientListeners(store);
    initClientStore(store);
};

const store = createStore();

if (window.__INITIAL_STATE__)
{
    store.replaceState(window.__INITIAL_STATE__);
}

window.Vue = Vue;
window.Vuex = Vuex;
window.NotificationService = NotificationService;
window.ceresTranslate = TranslationService.translate;
window.vueEventHub = new Vue();
window.ceresStore = store;

import "./app/main";
